import React from "react";
import Section from "../../Layouts/Section";
import Skill from "../../assets/images/skill.png";

const TechSkill = () => {
  return (
    <Section
      id="techSkillId"
      title="Tech Skill"
      className="flex flex-col gap-2 "
    >
      <span className="text-sm ">
        <b className="text-red-500">Language: </b>
        JavaScript, TypeScript, HTML, CSS, Java.
      </span>

      <span className="text-sm ">
        <b className="text-green-500 "> Libraries/Frameworks: </b>
        React, Three.js, Redux/Jotai, Tailwind CSS, AntDesign, Scss, Axios,
        ReactQuery, NodeJs, ExpressJS, Single SPA, ECharts.
      </span>

      <span className="text-sm ">
        <b className="text-blue-500"> Game / Realtime Tech: </b>
        Phaser, Playroomkit, Socket.io, HTML5 Canvas, WebGL, Game Physics,
        Multiplayer Game Logic.
      </span>

      <span className="text-sm ">
        <b className="text-purple-500"> Databases: </b>
        MySQL, MongoDB.
      </span>

      <span className="text-sm ">
        <b className="text-orange-500"> Tools/Platforms: </b>
        Vite, Webpack, GitLab, Jenkins, Docker, Jira, Confluence.
      </span>

      <span className="text-sm ">
        <b className="text-cyan-500"> OS: </b>
        Windows, MacOS.
      </span>

      <span className="text-sm ">
        <b className="text-yellow-500"> Additional Skills: </b>
        Playable Ads Optimization (&lt;5MB), SDK Integration (AppLovin,
        Airbridge), Performance Optimization, Agile methodologies,
        Problem-solving, Communication and Collaboration.
      </span>

      <div className=" w-full mt-16">
        <p className="text-center ">
          Currently, I'm using libraries and tools such as:
        </p>
      </div>

      <div className="w-full flex justify-center mt-4 ">
        <img
          className="max-w-[1280px] min-w-[340px] w-3/4"
          src={Skill}
          alt="Technical skills overview"
        />
      </div>
    </Section>
  );
};

export default TechSkill;
